import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import DownloadsList from "../../Components/common/client/downloads/DownloadsList";
import { updateactivePages } from "../../reducers/clientcommon";
import { fetchDownloads, setLoading } from "../../reducers/clientDownloads";
import useTitle from "../../utilities/hooks/useTitle";

const Downloads = () => {
  useTitle("Downloads");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(fetchDownloads({}));
    dispatch(
      updateactivePages({
        activePage: "downloads",
        activeSubPage: null,
      }),
    );
  }, []);
  return (
    <>
      <DownloadsList />
    </>
  );
};

export default Downloads;
